/**
 * Minimal stroke-icon set mirrored from the design reference's icon catalogue.
 * Only the glyphs the renderer needs are kept here.
 */
import type { CSSProperties } from 'react';

const ICON_PATHS: Record<string, string> = {
  check: '<path d="M20 6 9 17l-5-5"/>',
  chevronR: '<path d="m9 6 6 6-6 6"/>',
  arrowLeft: '<path d="M19 12H5M12 19l-7-7 7-7"/>',
  upload:
    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/>',
  shield:
    '<path d="M12 2 4 6v6c0 5 3.4 8 8 10 4.6-2 8-5 8-10V6Z"/><path d="m9 12 2 2 4-4"/>',
  send: '<path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/>',
  alert:
    '<circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/>',
  file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>',
  dot: '<circle cx="12" cy="12" r="3" fill="currentColor"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
};

export interface IconProps {
  name: keyof typeof ICON_PATHS | string;
  size?: number;
  stroke?: number;
  className?: string;
  style?: CSSProperties;
}

export function Icon({
  name,
  size = 18,
  stroke = 1.75,
  className = '',
  style,
}: IconProps) {
  const p = ICON_PATHS[name] ?? ICON_PATHS.dot ?? '';
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      dangerouslySetInnerHTML={{ __html: p }}
    />
  );
}
